/// <reference path="../css.d.ts" />

import cssText from '../../assets/style.css';

/**
 * Returns CSS for use inside the shadow root.
 * Strips the body.ct-w-modal-open rule (belongs on the light DOM)
 * and the @import url(...) for Google Fonts (handled via <link>).
 */
export function getShadowCss(): string {
  return cssText
    .replace(/@import\s+url\([^)]*\)\s*;?/g, '')
    .replace(/body\.ct-w-modal-open\s*\{[^}]*\}/g, '')
    .trim();
}

export function getInlineCss(): string {
  return getShadowCss();
}

/**
 * Returns only the body.ct-w-modal-open rule
 * for injection into the light DOM <head>.
 */
export function getBodyCss(): string {
  const match = cssText.match(/body\.ct-w-modal-open\s*\{[^}]*\}/);
  return match ? match[0] : '';
}

/**
 * Extracts the Google Fonts URL from the @import rule.
 */
export function getFontUrl(): string {
  const match = cssText.match(/@import\s+url\(['"]?([^'")\s]+)['"]?\)/);
  return match ? match[1] : '';
}
